import { format } from 'date-fns';
import { CHAT_ACTIVITY_TARGET, CHAT_ACTIVITY_TYPE, MESSAGE_TARGET } from '../../../utils/constants';
import { formatPrice } from '../../../utils/util';
import { Bubble, EventTime, Tooltip } from './CenteredBubble.styles';

const TARGET_MAPPER = {
  [MESSAGE_TARGET.FREE_PHOTO]: 'free photo',
  [MESSAGE_TARGET.FREE_VIDEO]: 'free video',
  [MESSAGE_TARGET.PREMIUM_PHOTO]: 'paid photo',
  [MESSAGE_TARGET.PREMIUM_VIDEO]: 'paid video',
  [MESSAGE_TARGET.SUBSCRIPTION]: 'subscription',
  [MESSAGE_TARGET.GIFT]: 'gift',
  [MESSAGE_TARGET.CUSTOM_VIDEO]: 'custom video',
  [MESSAGE_TARGET.NON_SPENDING_COUNTRY_TIP]: 'tip',
};
const CenteredBubble = ({ id, cost, url, target, type, metadata, timestamp }) => {
  return (
    <Bubble id={id} $url={!!url} target={target}>
      {type === CHAT_ACTIVITY_TYPE.OFFER && (
        <>
          Creator offered {TARGET_MAPPER[target]} - ${formatPrice(cost)}
        </>
      )}
      {type === CHAT_ACTIVITY_TYPE.PURCHASE && (
        <>
          User purchased {TARGET_MAPPER[target]} - ${formatPrice(cost)}
        </>
      )}
      {type === CHAT_ACTIVITY_TYPE.EVENT && target === MESSAGE_TARGET.SWITCH_CONVERSATION_PHASE && (
        <>
          {metadata?.oldPhase === 'MANUAL_CHAT' && <>AI turned ON</>}
          {metadata?.newPhase === 'MANUAL_CHAT' && <>AI turned OFF</>}
          {timestamp && <EventTime>{format(timestamp, 'HH:mm')}</EventTime>}
        </>
      )}
      {(target === CHAT_ACTIVITY_TARGET.PREMIUM_PHOTO ||
        target === CHAT_ACTIVITY_TARGET.FREE_PHOTO ||
        target === CHAT_ACTIVITY_TARGET.PREMIUM_VIDEO ||
        target === CHAT_ACTIVITY_TARGET.FREE_VIDEO) &&
        url && (
          <Tooltip className="tooltip">
            <img src={url} alt="tooltip-preview" />
          </Tooltip>
        )}
    </Bubble>
  );
};

export default CenteredBubble;
